<template>
  <span v-if="showable" :class="spanStateClass" :style="styles" @click.stop="$_toggleChecked">
    <i v-if="state" :class="prefixClass+'__prefix-icon'"></i>
    <t-icon v-if="createable" icon="plus-outline" :class="[prefixClass+'__plus', 'cursor-pointer']" @click.native.stop="$_onCreate"></t-icon>
    <span :class="prefixClass+'__title'">
      <slot></slot>
    </span>
    <t-icon v-if="closable" icon="close-outline" :class="[prefixClass+'-title__clear', 'cursor-pointer']" @click.native.stop="$_onClose"></t-icon>
  </span>
</template>

<script>
import { PREFIX_CLASS } from '../../utils/constants'

const PREFIX_TAG_CLASS = `${PREFIX_CLASS}tag`
export default {
  name: 'TTag',
  props: {
    state: {
      type: String,
      validator(value) {
        let validList = [
          'success',
          'danger',
          'warning',
          'muted',
          'info'
        ]
        return validList.includes(value)
      }
    },
    closable: Boolean,
    createable: Boolean,
    status: Boolean,
    bgColor: String,
    textColor: String,
    borderColor: String,
    padding: Number,
    checkable: Boolean
  },
  data() {
    return {
      prefixClass: PREFIX_TAG_CLASS,
      showable: true,
      checked: this.checkable
    }
  },
  computed: {
    spanStateClass() {
      return [
        `${PREFIX_TAG_CLASS}`,
        this.state ? `${PREFIX_TAG_CLASS}__${this.state} ${PREFIX_TAG_CLASS}__status` : '',
        this.closable ? `${PREFIX_TAG_CLASS}__closable` : '',
        this.createable ? `${PREFIX_TAG_CLASS}__create` : '',
        this.checkable ? `${PREFIX_TAG_CLASS}__checkable` : '',
        this.checked ? `checked` : ''
      ]
    },
    styles() {
      return {
        color: this.textColor,
        backgroundColor: this.bgColor,
        borderColor: this.borderColor,
        padding: this.padding + 'px'
      }
    }
  },
  methods: {
    // 删除自己
    $_onClose(e) {
      this.showable = false
      this.$emit('on-close', e)
    },
    $_onCreate(e) {
      this.$emit('on-create', e)
    },
    $_toggleChecked() {
      if (this.checkable) {
        this.checked = !this.checked
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/tag/tag.vue